export default "/images/bg-2.jpg?0b57bccc1bb20c5cbb0a7bd415397694";